import React, { useMemo, useState } from "react";
import { AttachmentDetails } from "./Attachments/AttachmentDetails";
import { AttachmentTable } from "./Attachments/AttachmentTable";
import { DOCUMENT_TYPE_FORMS_AGREEMENTS, DOCUMENT_TYPE_NOTICES_LETTERS, DOCUMENT_TYPE_SURETY_BONDS } from "../../../../app/constants";

export const AttachmentsTab = (props) => {
    const { 
        licenceApplication, 
        applicationType, 
        applicationMode, 
        isArchiveApplication 
    } = props;

    // console.log("ATTACHMENT", licenceApplication, appData)
    const { formsAgreements, noticesLetters } = useMemo(() => {
        const formsAgreements = []
        const noticesLetters = []
        const suretyBondDocs = []
        licenceApplication.documents.forEach((document) => {
            if(document.documentType === DOCUMENT_TYPE_FORMS_AGREEMENTS) {
                formsAgreements.push(document)
            } else if(document.documentType === DOCUMENT_TYPE_NOTICES_LETTERS) {
                noticesLetters.push(document)
            }
            else if(document.documentType === DOCUMENT_TYPE_SURETY_BONDS) {
                suretyBondDocs.push(document)
            }
        })
        return { formsAgreements, noticesLetters, suretyBondDocs}
    }, [licenceApplication.documents])

    const [attachment, setAttachment] = useState()

    return attachment 
    ? <AttachmentDetails isArchiveApplication={isArchiveApplication} attachment={attachment} licenceApplication={licenceApplication} setAttachment={setAttachment} applicationType={applicationType} applicationMode={applicationMode} />
    : <AttachmentTable isArchiveApplication={isArchiveApplication} formsAgreements={formsAgreements ?? []} noticesLetters={noticesLetters ?? []} licenceApplication={licenceApplication} applicationType={applicationType} applicationMode={applicationMode} setAttachment={setAttachment} />
}
